import { pagelist } from '../constants/constants'
//import Http from './http'

'use strict'

/**************************************
 * operations related to cookie
 ***************************************/

var cookie = {
  OTP: 'otp',
  STATION: 'station',
  TIMEZONE: 'timezone',
  NAME: 'name',
  ROLE: 'role',
  JOB_TITLE: 'job_title',
  USERNAME: 'username',
  ID: 'id',
  FIREBASETOKEN: 'firebasetoken',
  WEIGHT: 'weight',
  PPR: 'ppr',
  EXPIRY: 'expiry',
  TILES: 'tiles',
  TILES_BU: 'tiles_bu',
  TILES_BD: 'tiles_bd',
  LOGINTYPE: 'logintype',
  LOGINPAGE: 'loginpage',
}

// create cookie by name with specific path, domain and expiry time (if paased)
function createCookie(name, value, hours, path, domain) {
  //var cookie = name + "=" + escape(value) + ";";
  var cookie = name + '=' + (value || '0') + ';'
  // if (expires) {
  //   // If it's a date
  //   if (expires instanceof Date) {
  //     // If it isn't a valid date
  //     if (isNaN(expires.getTime())) expires = new Date();
  //   } else
  //     expires = new Date(
  //       new Date().getTime() + parseInt(expires) * 1000 * 60 * 60
  //     );
  //   cookie += "expires=" + expires.toGMTString() + ";";
  // }
  var expires = ''
  if (hours) {
    var date = new Date()
    date.setTime(date.getTime() + hours * 60 * 60 * 1000)
    expires = '; expires=' + date.toGMTString()
  } else {
    expires = ''
  }
  cookie += expires + ';'

  if (path) cookie += 'path=' + path + ';'
  if (domain) cookie += 'domain=' + domain + ';'

  if (typeof window !== 'undefined') {
    document.cookie = cookie
  }
}

// get cookie value from name
function getCookie(name) {
  var nameEQ = name + '='
  var ca
  if (typeof window !== 'undefined') {
    ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
  }
  return null
}

// delete specific cookie by name
function deleteCookie(name) {
  // If the cookie exists
  if (getCookie(name)) {
    //createCookie(name, '', -1, path, domain);
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/'
  }
}

// async function logout2() {
//   window.location.href = '/logout'
//   //const PPR = getCookie(COOKIE.PPR)
//   // window.open('https://ssaasi.delta.com/idp/startSLO.ping', '_blank')
//   // setTimeout(() => {
//   //   deleteCookie(COOKIE.OTP)
//   //   deleteCookie(COOKIE.STATION)
//   //   deleteCookie(COOKIE.TIMEZONE)
//   //   deleteCookie(COOKIE.ROLE)
//   //   deleteCookie(COOKIE.JOB_TITLE)
//   //   deleteCookie(COOKIE.NAME)
//   //   deleteCookie(COOKIE.USERNAME)
//   //   deleteCookie(COOKIE.WEIGHT)
//   //   deleteCookie(COOKIE.ID)
//   //   deleteCookie(COOKIE.PPR)
//   //   deleteCookie(COOKIE.EXPIRY)
//   //   window.location.href = '/dashboard'
//   // }, 3000)
//   // await Http.get(`user_logout?ppr=${PPR}`).then((resp) => {
//   //   // eslint-disable-next-line no-console
//   //   console.log('resp',resp)
//   //   window.open('https://ssaasi.delta.com/idp/startSLO.ping', '_blank')
//   //   setTimeout(() => {
//   //     window.location.href = '/dashboard'
//   //   }, 3000)
//   // })
// }
async function logout(){
  let ENV = process.env.REACT_APP_ENV
  let url = null
  if(ENV === 'stage' ){
    url = 'https://ssaasi.delta.com/idp/startSLO.ping?prompt=login'
  } else if(ENV === 'production' ){
    url = 'https://ssaa.delta.com/idp/startSLO.ping?prompt=login'
  }
  if(url){
    const opened = window.open(url, '_blank')
    setTimeout(() => {
      opened.close()
      deleteCookie(COOKIE.OTP)
      deleteCookie(COOKIE.STATION)
      deleteCookie(COOKIE.TIMEZONE)
      deleteCookie(COOKIE.ROLE)
      deleteCookie(COOKIE.JOB_TITLE)
      deleteCookie(COOKIE.NAME)
      deleteCookie(COOKIE.USERNAME)
      deleteCookie(COOKIE.WEIGHT)
      deleteCookie(COOKIE.ID)
      deleteCookie(COOKIE.PPR)
      deleteCookie(COOKIE.EXPIRY)
      deleteCookie(COOKIE.LOGINTYPE)
      deleteCookie(COOKIE.LOGINPAGE)
      window.location.href = '/dashboard'
    }, 5000)
  } else {
    deleteCookie(COOKIE.OTP)
    deleteCookie(COOKIE.STATION)
    deleteCookie(COOKIE.TIMEZONE)
    deleteCookie(COOKIE.ROLE)
    deleteCookie(COOKIE.JOB_TITLE)
    deleteCookie(COOKIE.NAME)
    deleteCookie(COOKIE.USERNAME)
    deleteCookie(COOKIE.WEIGHT)
    deleteCookie(COOKIE.ID)
    deleteCookie(COOKIE.PPR)
    deleteCookie(COOKIE.EXPIRY)
    deleteCookie(COOKIE.LOGINTYPE)
    deleteCookie(COOKIE.LOGINPAGE)
    window.location.href = '/login'
  }
}

function pageHandler(url, role) {
  if(!role){
    //logout()
    window.location.href = '/dashboard'
  }else {
    let row = pagelist.find((item) => item?.link === url)
    if (row){
      if(row.roles.indexOf(role) > '-1'){
        //do nothing
      } else {
        if(role === 'Super Admin' || role === 'Station Leader'){
          window.location.href = '/system-parameter/fleet'
        } else if(role === 'User' || role === 'Re-booking Team'){
          window.location.href = '/rebooking-queue'
        } else if(role === 'Warehouse TV'){
          window.location.href = '/landing-page'
        } else if(role === 'DOD Agent' || role === 'Centralized DoD'){
          window.location.href = '/dod-command-center'
        } else {
          logout()
        }
      }
    } else {
      if(role === 'Super Admin' || role === 'Station Leader'){
        window.location.href = '/system-parameter/fleet'
      } else if(role === 'User' || role === 'Re-booking Team'){
        window.location.href = '/rebooking-queue'
      } else if(role === 'Warehouse TV'){
        window.location.href = '/landing-page'
      } else if(role === 'DOD Agent' || role === 'Centralized DoD'){
        window.location.href = '/dod-command-center'
      } else {
        logout()
      }
    }
  }
}
let COOKIE = cookie
// module.exports = {
//   COOKIE: cookie,
//   createCookie: createCookie,
//   getCookie: getCookie,
//   deleteCookie: deleteCookie,
//   pageHandler: pageHandler,
// }

export { COOKIE, createCookie, getCookie, deleteCookie, pageHandler, logout }
